import { loadingConstants } from '../constants'

const setLoading = show => ({
  type: loadingConstants.SHOW_LOADING,
  show
})

export const loadingActions = {
  setLoading
}
